module.exports = __webpack_public_path__ + "static/media/iconList.5076ae96.svg";